import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { LearningPathsListPage } from '@/features/essays';

export const Route = createFileRoute('/redacoes/trilha-de-aprendizagem')({
  staticData: { title: 'Redações - Trilha de aprendizagem' },
  component: LearningPathsTabRoute,
});

function LearningPathsTabRoute(): JSX.Element {
  return <LearningPathsListPage />;
}
